import React from 'react';
import { TransformComponent, TransformWrapper } from 'react-zoom-pan-pinch';
import Image from 'next/legacy/image';

import { Building, EntityWithId } from '../../apolloClient/types';
import { Listing } from '../../apolloClient/types/Units';
import { useFloorplanImage } from '../../hooks/useFloorplanImage';
import ZoomWrapper from '../ZoomWrapper';

import BuildingFloorplanBody from './BuildingFloorplanBody';
import UnitFloorplanBody from './UnitFloorplanBody';

interface FloorplanPopupBodyProps {
  initialSitePlan?: boolean;
  initialActiveRowIndex?: number;
  entity: Building | Listing;
  bodyType: 'listing' | 'building';
  buildingFloorPlanImage?: Building['floorPlanImage'];
}

const FloorplanPopup: React.FC<FloorplanPopupBodyProps> = ({
  initialSitePlan = true,
  initialActiveRowIndex = 0,
  entity,
  bodyType,
  buildingFloorPlanImage,
}) => {
  const { activeRowIndex, floorplan, openSitePlan, openImage, imageSrc } =
    useFloorplanImage({
      initialSitePlan,
      initialActiveRowIndex,
      entity,
      bodyType,
      buildingFloorPlanImage,
    });

  return (
    <div className="flex flex-col mb-36 xl:flex-row xl:justify-between">
      <div className="relative border border-gold-dark xl:w-[65%] h-96 md:h-112 xl:h-[70vh]">
        <TransformWrapper initialScale={1}>
          {({ zoomIn, zoomOut, resetTransform }) => (
            <React.Fragment>
              <TransformComponent
                wrapperStyle={{ width: '100%', height: '100%' }}
                contentStyle={{ width: '100%', height: '100%' }}
              >
                <div className="relative flex items-center justify-center w-full h-[calc(100%-2.75rem)]">
                  <div className="w-full h-full">
                    <Image
                      className="object-contain object-center w-full h-full"
                      src={imageSrc}
                      blurDataURL={imageSrc}
                      placeholder="blur"
                      loading="eager"
                      layout="fill"
                      alt="image-floorplan"
                    />
                  </div>
                </div>
              </TransformComponent>
              <ZoomWrapper
                zoomIn={zoomIn}
                zoomOut={zoomOut}
                resetTransform={resetTransform}
                initialActiveRowIndex={activeRowIndex}
              />
            </React.Fragment>
          )}
        </TransformWrapper>
      </div>
      <div className="mt-16 xl:mt-0 xl:ml-[40px] xl:w-[35%]">
        {bodyType === 'building' && (
          <BuildingFloorplanBody
            building={entity as Building}
            activeRowIndex={activeRowIndex}
            openImage={openImage}
            openSitePlan={openSitePlan}
          />
        )}
        {bodyType === 'listing' && (
          <UnitFloorplanBody
            floorplan={floorplan}
            listing={entity as EntityWithId<Listing>}
          />
        )}
      </div>
    </div>
  );
};

export default FloorplanPopup;
